import PropTypes from 'prop-types';

export const CriteriaPropType = PropTypes.shape({
    check: PropTypes.func.isRequired,
    compare: PropTypes.func.isRequired,
    prepare: PropTypes.func,
});
